/**
 * Do not edit directly
 * Generated on Thu, 30 Jul 2026 11:19:39 GMT
 */

module.exports = {
  '-ds-core-100': {
    value: '#F9F5F2',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#F9F5F2',
    },
    name: 'DsCore100',
    attributes: {
      category: '-ds-core-100',
    },
    path: ['-ds-core-100'],
  },
  '-ds-core-200': {
    value: '#FEC077',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FEC077',
    },
    name: 'DsCore200',
    attributes: {
      category: '-ds-core-200',
    },
    path: ['-ds-core-200'],
  },
  '-ds-core-300': {
    value: '#0C393F',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#0C393F',
    },
    name: 'DsCore300',
    attributes: {
      category: '-ds-core-300',
    },
    path: ['-ds-core-300'],
  },
  '-ds-core-400': {
    value: '#0C6776',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#0C6776',
    },
    name: 'DsCore400',
    attributes: {
      category: '-ds-core-400',
    },
    path: ['-ds-core-400'],
  },
  '-ds-core-50': {
    value: '#FFF5F0',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FFF5F0',
    },
    name: 'DsCore50',
    attributes: {
      category: '-ds-core-50',
    },
    path: ['-ds-core-50'],
  },
  '-ds-error-100': {
    value: '#FCF5F6',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FCF5F6',
    },
    name: 'DsError100',
    attributes: {
      category: '-ds-error-100',
    },
    path: ['-ds-error-100'],
  },
  '-ds-error-200': {
    value: '#FA9E9E',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FA9E9E',
    },
    name: 'DsError200',
    attributes: {
      category: '-ds-error-200',
    },
    path: ['-ds-error-200'],
  },
  '-ds-error-300': {
    value: '#AB000D',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#AB000D',
    },
    name: 'DsError300',
    attributes: {
      category: '-ds-error-300',
    },
    path: ['-ds-error-300'],
  },
  '-ds-information-100': {
    value: '#F7F8FA',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#F7F8FA',
    },
    name: 'DsInformation100',
    attributes: {
      category: '-ds-information-100',
    },
    path: ['-ds-information-100'],
  },
  '-ds-information-200': {
    value: '#B1B9E3',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#B1B9E3',
    },
    name: 'DsInformation200',
    attributes: {
      category: '-ds-information-200',
    },
    path: ['-ds-information-200'],
  },
  '-ds-information-300': {
    value: '#3E4A7C',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#3E4A7C',
    },
    name: 'DsInformation300',
    attributes: {
      category: '-ds-information-300',
    },
    path: ['-ds-information-300'],
  },
  '-ds-neutral-100': {
    value: '#FFFFFF',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FFFFFF',
    },
    name: 'DsNeutral100',
    attributes: {
      category: '-ds-neutral-100',
    },
    path: ['-ds-neutral-100'],
  },
  '-ds-neutral-200': {
    value: '#F7F8F6',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#F7F8F6',
    },
    name: 'DsNeutral200',
    attributes: {
      category: '-ds-neutral-200',
    },
    path: ['-ds-neutral-200'],
  },
  '-ds-neutral-300': {
    value: '#CBCCCB',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#CBCCCB',
    },
    name: 'DsNeutral300',
    attributes: {
      category: '-ds-neutral-300',
    },
    path: ['-ds-neutral-300'],
  },
  '-ds-neutral-400': {
    value: '#A0A09F',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#A0A09F',
    },
    name: 'DsNeutral400',
    attributes: {
      category: '-ds-neutral-400',
    },
    path: ['-ds-neutral-400'],
  },
  '-ds-neutral-500': {
    value: '#767676',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#767676',
    },
    name: 'DsNeutral500',
    attributes: {
      category: '-ds-neutral-500',
    },
    path: ['-ds-neutral-500'],
  },
  '-ds-neutral-600': {
    value: '#494948',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#494948',
    },
    name: 'DsNeutral600',
    attributes: {
      category: '-ds-neutral-600',
    },
    path: ['-ds-neutral-600'],
  },
  '-ds-neutral-700': {
    value: '#1D1D1D',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#1D1D1D',
    },
    name: 'DsNeutral700',
    attributes: {
      category: '-ds-neutral-700',
    },
    path: ['-ds-neutral-700'],
  },
  '-ds-success-100': {
    value: '#F5F8F8',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#F5F8F8',
    },
    name: 'DsSuccess100',
    attributes: {
      category: '-ds-success-100',
    },
    path: ['-ds-success-100'],
  },
  '-ds-success-200': {
    value: '#91C4BD',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#91C4BD',
    },
    name: 'DsSuccess200',
    attributes: {
      category: '-ds-success-200',
    },
    path: ['-ds-success-200'],
  },
  '-ds-success-300': {
    value: '#0A4E45',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#0A4E45',
    },
    name: 'DsSuccess300',
    attributes: {
      category: '-ds-success-300',
    },
    path: ['-ds-success-300'],
  },
  '-ds-warning-100': {
    value: '#FCF6F5',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FCF6F5',
    },
    name: 'DsWarning100',
    attributes: {
      category: '-ds-warning-100',
    },
    path: ['-ds-warning-100'],
  },
  '-ds-warning-200': {
    value: '#FFBC97',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FFBC97',
    },
    name: 'DsWarning200',
    attributes: {
      category: '-ds-warning-200',
    },
    path: ['-ds-warning-200'],
  },
  '-ds-warning-300': {
    value: '#A12001',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#A12001',
    },
    name: 'DsWarning300',
    attributes: {
      category: '-ds-warning-300',
    },
    path: ['-ds-warning-300'],
  },
}
